import {FormattedMessage} from "react-intl"
import React from "react"

export default {
	load() {
		return {
			fields: {
				name: {
					label: <FormattedMessage id="Common.label.name" />,
					rules: "required"
				},
				chipData: {
					// label: <FormattedMessage id="Patient.form.bmiform.height" />,
					value: "[]"
					// rules: ""
				},
				_id: {}
			}
		}
	}
}
